import { render } from "./AdDocViewInvitationsEmpty.vue?vue&type=template&id=166728fe&ts=true"
import script from "./AdDocViewInvitationsEmpty.vue?vue&type=script&lang=ts"
export * from "./AdDocViewInvitationsEmpty.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__